import {
  FreeSoloAutocompleteWithLabel,
  InputWithLabel
} from '@adotel/components'
import { Collapse } from '@material-ui/core'
import Switch from '@material-ui/core/Switch'
import Typography from '@material-ui/core/Typography'

import { getTranslate } from '../../../../localization'
import {
  ModifyAdminConfigLogInput,
  ThresholdSettings
} from '../../../../types/adminConfig'
import useStyles from './index.styles'

type Props = {
  thresholdSettings: ThresholdSettings | undefined
  modifyAdminLogInput: ModifyAdminConfigLogInput
  setmodifyAdminLogInput: React.Dispatch<
    React.SetStateAction<ModifyAdminConfigLogInput>
  >
}
export default function ThresholdSetting({
  modifyAdminLogInput,
  setmodifyAdminLogInput
}: Props) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography variant="h4" className={classes.title}>
          {getTranslate('Threshold Settings')}
        </Typography>
        <Typography className={classes.subtitle}>
          {getTranslate('Configure record limits and notifications')}
        </Typography>
      </div>
      <div>
        <InputWithLabel
          label={getTranslate('Number of Records')}
          value={modifyAdminLogInput.thresholdSettings.numberOfrecordes}
          onChange={(event) => {
            const value = event.currentTarget.value
            if (!/^\d*$/.test(value)) return
            setmodifyAdminLogInput({
              ...modifyAdminLogInput,
              thresholdSettings: {
                ...modifyAdminLogInput.thresholdSettings,
                numberOfrecordes: Number(value)
              }
            })
          }}
          min={0}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          noHelperText
          inputSize={'small'}
          className={classes.input}
        />
      </div>
      <div className={classes.divider} />
      <div>
        <Typography className={classes.fieldLabel}>
          {getTranslate('SMS Notifications')}
        </Typography>
        <div className={classes.toggleRow}>
          <div className={classes.toggleText}>
            <Typography className={classes.fieldLabel}>
              {getTranslate('Enable SMS Alerts')}
            </Typography>
            <Typography variant="h5" className={classes.helperText}>
              {getTranslate('Receive SMS when threshold is reached')}
            </Typography>
          </div>
          <Switch
            color="primary"
            checked={
              modifyAdminLogInput.thresholdSettings.enabledSMSNotifications
            }
            onChange={(event) => {
              setmodifyAdminLogInput({
                ...modifyAdminLogInput,
                thresholdSettings: {
                  ...modifyAdminLogInput.thresholdSettings,
                  enabledSMSNotifications: event.target.checked
                }
              })
            }}
          />
        </div>
        <Collapse
          in={modifyAdminLogInput.thresholdSettings.enabledSMSNotifications}
          timeout={500}
          className={classes.collapse}>
          <InputWithLabel
            label={getTranslate('Maximum Threshold for SMS Notifications')}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            value={
              modifyAdminLogInput?.thresholdSettings.intervalSMSNotifications
            }
            onKeyDown={(e) => {
              if (e.key === '-' || e.key === 'e' || e.key === '.') {
                e.preventDefault()
              }
            }}
            helpertext={getTranslate(
              'Maximum number of SMS notifications to send per security event'
            )}
            onChange={(event) => {
              const value = event.currentTarget.value
              if (!/^\d*$/.test(value)) return
              setmodifyAdminLogInput({
                ...modifyAdminLogInput,
                thresholdSettings: {
                  ...modifyAdminLogInput.thresholdSettings,
                  intervalSMSNotifications: Number(value)
                }
              })
            }}
            error={
              modifyAdminLogInput.thresholdSettings.enabledSMSNotifications &&
              modifyAdminLogInput.thresholdSettings.intervalSMSNotifications! <=
                0
            }
            inputSize={'small'}
            className={classes.input}
          />
          <div style={{ maxWidth: 320, width: '100%' }}>
            <FreeSoloAutocompleteWithLabel
              name="Hosts"
              label={getTranslate('Phone Numbers')}
              // helpertext={getTranslate('Use E.164 format (e.g., +1234567890)')}
              // placeholder={getTranslate('Enter the Host')}
              // onChange={(_, v: any) => {
              //   setFieldValue('Hosts', v)
              // }}
              value={modifyAdminLogInput.thresholdSettings.mobileNumbers}
              onChange={(_, values: string[]) => {
                setmodifyAdminLogInput({
                  ...modifyAdminLogInput,
                  thresholdSettings: {
                    ...modifyAdminLogInput.thresholdSettings,
                    mobileNumbers: values
                  }
                })
              }}
              options={[]}
              message={''}
              regexPattern={/^(?:\+98|0)\d{10}$/}
              size="small"
              // value={values.Hosts}
              inputSize="small"
              // error={(touched.Hosts && !!errors.Hosts) || undefined}
              // onBlur={handleBlur}
              // disabled={isSubmitting}
              className={classes.input}
              limitTags={1}
            />
          </div>
        </Collapse>
      </div>
    </div>
  )
}
